module.exports = __webpack_public_path__ + "media/images/area/icon_weather_5-781dbee62bf1414693ccf25b1352912b.png";